import React, { useState, useEffect } from 'react';
 
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from 'react-bootstrap/Modal';
import Plantilla from './plantillas/Plantilla'
import { SignOutButton } from './office365auth/SignOutButton';

import { getConfiguration } from '../api/config'

export const CountdownTimer = () => {
    const [showModalTimeout, setShowModalTimeout] = useState(false);
    const [performSignOut, setPerformSignOut] = useState(false);
    const [leftSeconds, setLeftSeconds] = useState(getConfiguration().seleccionHorarioTimeoutSeconds);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(true);
        document.seleccionHorarioTimeoutSeconds = getConfiguration().seleccionHorarioTimeoutSeconds;
    }, []);

    useEffect(() => {
        if (!isLoaded) return;
        if (leftSeconds <= 0) {
            setShowModalTimeout(true);
            return;
        }

        setTimeout(() => {
            document.seleccionHorarioTimeoutSeconds = document.seleccionHorarioTimeoutSeconds - 1;
            setLeftSeconds(document.seleccionHorarioTimeoutSeconds);
        }, 1000)
    }, [leftSeconds, isLoaded]);
    
    const minutes = ("00" + Math.floor(leftSeconds / 60)).substr(-2);
    const seconds = ("00" + (leftSeconds % 60)).substr(-2);
    let timer = `${minutes}:${seconds}`;
    if (leftSeconds === undefined) timer = "00:00";
    let color = (leftSeconds < 60) ? "var(--red)" : 'var(--blue)';
    let position = (leftSeconds < 60) ? "fixed" : 'absolute';

    return (
        <>
            <div className="countdown-container">
                <div className="countdown-timer" style={{ position }}>
                    <div style={{ color: color }}>{timer}</div>
                    <div style={{ display: "none" }}>
                        {/* {performSignOut && console.log("signout")} */}
                        {performSignOut && <SignOutButton performSignOut={performSignOut} />}
                    </div>
                </div>
            </div>

            <ModalTimeout show={showModalTimeout} onClose={() => { setPerformSignOut(true) }} />
        </>
    );
}


const ModalTimeout = ({ show, onClose }) => {
    const handleClose = () => { onClose() };

    return (<>
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} centered style={{ maxHeight: "100%" }}>
            <Modal.Body>
                <Row>
                    <Plantilla id="SessionTimeout" />
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Row style={{ display: "contents" }}>
                    <Col className="d-grid gap-2" >
                        <Button variant="primary" onClick={handleClose}>
                            Aceptar
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
    </>);
};